import { render, staticRenderFns } from "./ChangeCourierForDeliveredOrder.vue?vue&type=template&id=56602ecd"
import script from "./ChangeCourierForDeliveredOrder.vue?vue&type=script&lang=js"
export * from "./ChangeCourierForDeliveredOrder.vue?vue&type=script&lang=js"
import style0 from "./ChangeCourierForDeliveredOrder.vue?vue&type=style&index=0&id=56602ecd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports